import proptypes from 'prop-types';

const {
  string, func, oneOfType, number, shape, bool
} = proptypes;

export const propTypes = {
  itemId: string.isRequired,
  onClick: func,
  onHover: func,
  productType: string,
  impressionData: shape({
    id: string,
    component: string,
    type: string
  }),
  name: string,
  noPipSpacing: bool
};

export const defaultProps = {
  onClick: null,
  onHover: null,
  productType: 'Products',
  impressionData: {
    id: null,
    component: null,
    type: null
  },
  name: null,
  noPipSpacing: false
};

export const impressionContainerNameParser = (title) => {
  if (title && typeof title === 'string') {
    const name = title.replace(/ /g, '');
    return name;
  }
  return '';
};